/* Component Dependencies */
var servicesAndAmenitiesTemplate = require('templates/servicesAndAmenities.hbs');
var AriesComponent = require('libs/aries-component');

AriesComponent.create({
  type: 'servicesAndAmenities',
  template: {
    'servicesAndAmenities': servicesAndAmenitiesTemplate
  }
});
